module.exports = __webpack_public_path__ + "img/down-stright-arros.5dcc2b0b.svg";